import { useMemo } from "react";
import { queries } from "../../shared/queries";
import type { Permission } from "../../shared/rbac/permissions";
import { isTenantScopeGrant } from "../../shared/rbac/permissions";
import { grantHasPermission } from "../../shared/rbac/roles";
import { useQuery } from "./useQuery";

export function useHasAccess(
  permission: Permission,
  scopeId?: string
): boolean {
  const tenantScope = !scopeId;
  const [allMyGrants] = useQuery(queries.currentUserGrants());
  const scopeGrants = useMemo(
    () =>
      allMyGrants?.filter((g) =>
        tenantScope ? isTenantScopeGrant(g) : g.scopeId === scopeId
      ) ?? [],
    [allMyGrants, tenantScope, scopeId]
  );
  const isAdmin = useMemo(() => {
    if (!allMyGrants || tenantScope) return false;
    return allMyGrants.some(
      (g) => isTenantScopeGrant(g) && grantHasPermission(g, "allow_all")
    );
  }, [allMyGrants, tenantScope]);
  return isAdmin || scopeGrants.some((g) => grantHasPermission(g, permission));
}
